<template>

  <div class="vflex">

    <div class="vflex-row-0 vflex-header p-3">
      <div class="page-title">
        <div class="title">
          <h4>{{ $t('Time to fill') }}</h4>
        </div>
        <div>
          <div class="form-inline">
            <div class="form-group mr-2">
              <range-date-filter
                :value="rangeDate"
                @input="(v) => { setFilters({update_status_date: v}) }"
                style="min-width: 210px"> 
                </range-date-filter>
            </div>
            <button
              class="btn btn-light"
              @click="exportReport">
              {{ $t('Export xlsx') }}
              </button>
          </div>
        </div>
      </div>
    </div>

    <div class="vflex-row-1">
      
      <filterfy
        :models="filtersMap"
        :initFilters="filters"
        @changed="setFilters">

        <Paginaty
          :total="grid.total"
          :pages="grid.pages"
          :page="grid.page"
          :creating="creating"
          :loading="loading"
          @changePage="setPage">
          
          <template slot="content">
            <table class="table table-bordered">
              <thead class="thead-fixed">
                 <tr>
                  <th-sort
                    field="title"
                    :value="sort"
                    @input="setSort">{{ $t('Job') }}</th-sort>
                  <th-sort
                    field="company_name"
                    :value="sort"
                    @input="setSort">{{ $t('Company') }}</th-sort>
                  <th-sort
                    field="departament_name"
                    :value="sort"
                    @input="setSort">{{ $t('Department') }}</th-sort>
                  <th-sort
                    field="owner_user_name"
                    :value="sort"
                    @input="setSort">{{ $t('Responsável') }}</th-sort>
                  <th-sort
                    field="openings"
                    :value="sort"
                    @input="setSort">{{ $t('Openings') }}</th-sort>
                  <th-sort
                    field="date_open"
                    :value="sort"
                    @input="setSort">{{ $t('Opening date') }}</th-sort>
                  <th-sort
                    field="date_close"
                    :value="sort"
                    @input="setSort">Previsão Fechamento</th-sort>
                  <th-sort
                    field="deadline_days"
                    :value="sort"
                    @input="setSort">{{ $t('Deadline') }}</th-sort>
                  <th-sort
                    field="total_hireds"
                    :value="sort"
                    @input="setSort">{{ $t('Hireds') }}</th-sort>
                  <th-sort
                    field="last_hired"
                    :value="sort"
                    @input="setSort">{{ $t('Last hired') }}</th-sort>
                  <th-sort
                    field="days_to_fill"
                    :value="sort"
                    @input="setSort">{{ $t('Time to fill') }}</th-sort>
                  <th-sort
                    field="deadline_percent"
                    :value="sort"
                    @input="setSort">{{ $t('Time/Deadline') }}</th-sort>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in grid.docs">
                  <th class="text-truncate"><router-link :to="{path: '/job/' + item._id }">{{ item.title }}</router-link> #{{ item.code }}</th>
                  <td class="text-truncate">{{ item.company_name }}</td>
                  <td class="text-truncate">{{ item.departament_name }}</td>
                  <td class="text-truncate">{{ item.owner_user_name }}</td>
                  <td class="text-truncate">{{ item.openings }}</td>
                  <td class="text-truncate">{{ $d(new Date(item.date_open), 'short') }}</td>
                  <td class="text-truncate">{{ $d(new Date(item.date_close), 'short') }}</td>
                  <td class="text-truncate"><span v-if="$isNum(item.deadline_days)">{{ item.deadline_days }}d</span></td>
                  <td class="text-truncate">{{ item.total_hireds }}</td>
                  <td class="text-truncate"><span v-if="item.last_hired">{{ $d(new Date(item.last_hired), 'short') }}</span></td>
                  <td class="text-truncate"><span v-if="$isNum(item.days_to_fill)">{{ item.days_to_fill }}d</span></td>
                  <td class="text-truncate"><span v-if="$isNum(item.deadline_percent)" class="badge" :class="deadline_percentClass(item.deadline_percent)">{{ item.deadline_percent }}%</span></td>
                </tr>
              </tbody>
            </table>
          </template>

          <template slot="noresults">
            {{ $t('There are no items') }}
          </template>

        </Paginaty>

      </filterfy>
      
    </div>

  </div>

</template>

<script>
import Filterfy from '@/components/Filterfy/Filterfy'
import ThSort from '@/components/Parts/ThSort'
import Paginaty from '@/components/Paginaty/Paginaty'
import RangeDateFilter from './RangeDateFilter'
import BlobDownload from '@/utils/BlobDownload'
import FilterfyToQuery from '@/utils/FilterfyToQuery'
import moment from 'moment'

export default {
  name: 'ReportPipelineSpeed',
  components: {
    Filterfy,
    ThSort,
    Paginaty,
    RangeDateFilter
  },
  data () {
    return {
      creating: true,
      loading: true,
      filtersMap: [
        {
          'type': 'list',
          'label': 'Empresa',
          'target': 'company_id',
          'resource': 'companies'
        },
        {
          'type': 'list',
          'label': this.$t('Department'),
          'target': 'departament_id',
          'resource': 'departaments'
        },
        {
          'type': 'list',
          'label': this.$t('Owner'),
          'target': 'owner_user_id',
          'resource': 'users'
        }
      ],
      grid: false
    }
  },
  computed: {
    filters () {
      return this.$route.query
    },
    sort () {
      return this.$route.query.sort || '-last_hired'
    },
    rangeDate () {
      const defaultDate = `d|${moment().subtract(30, 'days').toISOString()}|${moment().toISOString()}`
      return this.$route.query.update_status_date === undefined ? defaultDate : this.$route.query.update_status_date
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    /*
    loadData
    */
    loadData () {
      this.loading = true

      const params = {
        ...FilterfyToQuery(this.filters, this.filtersMap),
        update_status_date: this.rangeDate,
        page: this.$route.query.page || 1,
        sort: this.sort,
        limit: this.$default.limit
      }

      this.axios
      .get('/accounts/' + this.$store.getters.getAccount._id + '/reports/time-to-fill', {params: params})
      .then((response) => {
        this.grid = response.data
        this.loading = this.creating = false
      })
    },
    /*
    setFilters
    */
    setFilters (filters) {
      this.$changeUrlParam(filters)
      this.setPage(1)
    },
    setSort (sort) {
      this.$changeUrlParam({sort: sort})
      this.setPage(1)
    },
    setPage (page) {
      this.$changeUrlParam({page: page})
      this.loadData()
    },
    deadline_percentClass (percent) {
      if (percent >= 100) return 'badge-danger'
      else if (percent >= 70) return 'badge-warning'
      else return 'badge-success'
    },
    exportReport () {
      const params = {
        ...this.filters,
        sort: this.sort
      }

      this.axios
      .get('/accounts/' + this.$store.getters.getAccount._id + '/reports/time-to-fill/export', {params: params, responseType: 'blob', timeout: 30000})
      .then((response) => {
        BlobDownload(response)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Report/ReportTimeToFill.vue